'use strict';

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
/* global document, window */

var stringUtils = require('zero-lang/string');

var doc = document;
var html = doc.documentElement;
var testDiv = doc.createElement('div');

module.exports = {
    hasTextContent: 'textContent' in testDiv,
    hasClassList: 'classList' in testDiv,
    hasDataSet: 'dataset' in testDiv,
    canDnD: 'draggable' in testDiv,
    isQuirks: stringUtils.lc(doc.compatMode) === 'backcompat' || doc.documentMode === 5, // 怪异模式
    testDiv: testDiv,
    contains: 'compareDocumentPosition' in html ? function (element, container) {
        return (container.compareDocumentPosition(element) & 16) === 16;
    } : function (element, container) {
        container = container === doc || container === window ? html : container;
        return container !== element && container.contains(element);
    },
    isDomNode: function isDomNode(element) {
        var t = element.nodeType;
        return element && (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && (t === 1 || t === 9);
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-dom/utils.js
 ** module id = 18
 ** module chunks = 0 1
 **/